import { memo, ReactElement } from 'react';
import RegistryOffice from 'shell/components/shared/sipo-person-form/new-person/form/steps/registry-office';
import CivilStatus from 'shell/components/shared/sipo-person-form/new-person/form/steps/civil-status';
import OtherDatas from 'shell/components/shared/sipo-person-form/new-person/form/steps/other-datas';
import Document from 'shell/components/shared/sipo-person-form/new-person/form/steps/document';
import ResidenceOrigin from './steps/residence-origin';

interface ActiveStepProps {
  step?: number;
  isEdit?: boolean;
  typeRegister?: string;
}
const ActiveStepComponent = ({ step, isEdit, typeRegister }: ActiveStepProps): ReactElement => {
  switch (step) {
    case 0:
      return <RegistryOffice isEdit={isEdit} />;
    case 2:
      return <CivilStatus />;
    case 4:
      return <Document />; // bottone disabilitato
    case 5:
      return <OtherDatas isEdit={isEdit} />;
    case 6:
      return <ResidenceOrigin isEdit={isEdit} typeRegister={typeRegister} />;
    default:
      return <></>;
  }
};

ActiveStepComponent.displayName = 'Active step component';

const ActiveStep = memo(ActiveStepComponent) as typeof ActiveStepComponent;

export default ActiveStep;
